import { typedQueryClient, usePermanentRealTimeUser, useTypedQuery } from "hooks";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

export const setShowPriceInVat = (vat: boolean) => typedQueryClient.setQueryData(AppointmentDetailsKeys.showPriceInVat, vat);

export const useShowPriceInVat = () => {
  const appointmentLocation = useAppointmentLocation();
  const { user } = usePermanentRealTimeUser();

  return useTypedQuery({
    queryKey: AppointmentDetailsKeys.showPriceInVat,
    initialData: Boolean(appointmentLocation?.include_vat && user?.is_vat_enabled_on_wo)
  }).data;
};
